import { CustomSelectFieldProps, SelectField } from 'components/form'
import { useTiposOrigemDadoTransporteSelectFieldQuery } from 'graphql/hooks.generated'
import { TipoOrigemDadoTransporte } from 'graphql/types.generated'
import React from 'react'
import { emptyArrayOf } from 'util/array'

export type TiposOrigemDadoTransporteSelectFieldModel = TipoOrigemDadoTransporte

type TiposOrigemDadoTransporteSelectFieldProps = CustomSelectFieldProps<TiposOrigemDadoTransporteSelectFieldModel>

export const TiposOrigemDadoTransporteSelectField = React.memo((props: TiposOrigemDadoTransporteSelectFieldProps) => {
  const {
    loading,
    data: { tiposOrigemDadoTransporte = emptyArrayOf<TiposOrigemDadoTransporteSelectFieldModel>() },
  } = useTiposOrigemDadoTransporteSelectFieldQuery()

  return (
    <SelectField<TiposOrigemDadoTransporteSelectFieldModel>
      label='Origem do lote'
      items={tiposOrigemDadoTransporte as TiposOrigemDadoTransporteSelectFieldModel[]}
      itemToString={itemToString}
      loading={loading}
      {...props}
    />
  )
})

const itemToString = (item: TiposOrigemDadoTransporteSelectFieldModel): string => item?.descricao
